import { createContext } from "react";

type TableColumnSettingsContextType = {
  columnSettings: Record<string, boolean>;
  updateColumnSettings: (columnSettings: Record<string, boolean>) => void;
  getColumnSettings: () => Record<string, boolean> | undefined;
  columnOrder: string[];
  updateColumnOrder: (columnOrder: string[]) => void;
};

export const TableColumnSettingsContext = createContext<
  TableColumnSettingsContextType | undefined
>(undefined);
